export const LEAD_POPUP_DELAY_MS = 15000;

export const isLeadPopupEligible = ({
  enabled,
  delayComplete,
  dismissed,
  excludedPath,
  signedIn
}) => enabled && delayComplete && !dismissed && !excludedPath && !signedIn;
